import { useGetAgency } from "@/components/parts/admin/agency/api";
import { useGetCategoryAspiration } from "@/components/parts/admin/aspiration/api";
import { useElectoralDistrict } from "@/components/parts/admin/electoral-district/api";
import { useGetFraksi } from "@/components/parts/admin/fraksi/api";
import { useGetKomisi } from "@/components/parts/admin/komisi/api";
import {
  useGetRank,
  useGetWorkUnit,
} from "@/components/parts/admin/manage-account/jabatan/api";
import {
  useGetMember,
  useGetMemberDistricts,
} from "@/components/parts/admin/member/api";
import { useGetPeriod } from "@/components/parts/admin/period/api";
import { useGetPosition } from "@/components/parts/admin/position/api";
import { useGetSector } from "@/components/parts/admin/sector/api";
import { useGetTools } from "@/components/parts/admin/tools/api";
import { useGetTotalMap } from "@/components/parts/map/api";
import { useRegionNames } from "@/components/parts/regions/api";

export const useFraksiOptions = () => {
  const { data: Fraksi } = useGetFraksi("limit=99");

  const fraksiOptions =
    Fraksi?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return fraksiOptions;
};

export const useMemberOptions = (
  formDapilId?: string,
  formFractionId?: string,
  formMemberId?: string,
  formDistrictId?: number
) => {
  const paramsDapil =
    formDapilId && !formMemberId ? `&dapilId=${formDapilId}` : "";
  const paramsFraksi =
    formFractionId && !formMemberId ? `&fraksiId=${formFractionId}` : "";
  const paramsDistrict =
    formDistrictId && !formMemberId ? `&kecamatanId=${formDistrictId}` : "";
  const { data: Member } = useGetMember(
    `limit=99&role=anggota${paramsDapil}${paramsFraksi}${paramsDistrict}`
  );

  const memberOptions =
    Member?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return memberOptions;
};

export const useDapilOptions = () => {
  const { data: Dapil } = useElectoralDistrict("limit=99");

  const DapilOptions =
    Dapil?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return DapilOptions;
};

export const useKomisiOptions = () => {
  const { data: Komisi } = useGetKomisi("limit=99");
  const KomisiOptions =
    Komisi?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return KomisiOptions;
};

export const useRankOptions = () => {
  const { data: Rank } = useGetRank("limit=99");

  const RankOptions =
    Rank?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return RankOptions;
};

export const useWorkUnitOptions = () => {
  const { data: WorkUnit } = useGetWorkUnit("limit=99");

  const WorkUnitOptions =
    WorkUnit?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return WorkUnitOptions;
};

export const useSectorOptions = () => {
  const { data: Sector } = useGetSector("limit=99");

  const SectorOptions =
    Sector?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return SectorOptions;
};

export const useToolsOptions = () => {
  const { data: Tools } = useGetTools("limit=99");

  const ToolsOptions =
    Tools?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return ToolsOptions;
};

export const useCategoryAspirationOptions = () => {
  const { data: Category } = useGetCategoryAspiration("limit=99");
  const CategoryOptions =
    Category?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return CategoryOptions;
};

export const useDistrictId = (code: string) => {
  const { district } = useRegionNames(
    {
      district: code,
    },
    ["district"]
  );

  const { data } = useGetMemberDistricts("");
  const value = data?.data.items.find(
    (item) => item.name.substring(0, 10) === district?.substring(0, 10)
  )?.id;

  return value;
};

export const useAgencyOptions = () => {
  const { data: Agency } = useGetAgency("limit=99");

  const AgencyOptions =
    Agency?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return AgencyOptions;
};

export const usePeriodOptions = () => {
  const { data: Period } = useGetPeriod("limit=99");

  const PeriodOptions =
    Period?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return PeriodOptions;
};

export const usePositionOptions = () => {
  const { data: Position } = useGetPosition("limit=99");

  const PositionOptions =
    Position?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return PositionOptions;
};
